export default __webpack_public_path__ + "static/media/stcPay.bdfde662.svg";